import React, { useState } from 'react';
import './Header.css';
import youtubeButton from '../assets/网站设计/PC端切图/youtube按钮.webp';
import logoMobile from '../assets/网站设计/移动端切图/logo.webp';
import logoDesktop from '../assets/网站设计/PC端切图/logo.webp';

interface HeaderProps {
  isMobile: boolean;
}

const Header: React.FC<HeaderProps> = ({ isMobile }) => {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  const handleCloseModal = () => {
    setActiveVideo(null);
  };

  return (
    <>
      <header className={`header ${isMobile ? 'header--mobile' : 'header--desktop'}`}>
        <div className="header__logo">
          <img
            src={isMobile ? logoMobile : logoDesktop}
            alt="PAX AUTOCRATICA Logo"
            className="header__logo-img"
          />
        </div>
        <h1 className="header__title">
          {isMobile ? (
            <>SATIRICAL TOTALITARIAN<br />COLONY SIM & FPS ROGUELITE</>
          ) : (
            'SATIRICAL TOTALITARIAN COLONY SIM & FPS ROGUELITE'
          )}
        </h1>
        <p className="header__subtitle">
          Command your troops through large-scale sci-fi battlefields' intense chaos.
        </p>
        <div className="header__trailer-buttons">
          <button
            className="header__trailer-btn"
            onClick={() => setActiveVideo('PKHmwx0iebA')}
          >
            <img
              src={youtubeButton}
              alt="YouTube Button"
              className="trailer-btn-img"
            />
            <span className="trailer-btn-text">TRAILER</span>
          </button>
          <button
            className="header__trailer-btn"
            onClick={() => setActiveVideo('c2iHV10cE_s')}
          >
            <img
              src={youtubeButton}
              alt="YouTube Button"
              className="trailer-btn-img"
            />
            <span className="trailer-btn-text">BATTLE</span>
          </button>
        </div>
      </header>

      {activeVideo && (
        <div className="video-modal" onClick={handleCloseModal}>
          <div className="video-modal__content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal__close" onClick={handleCloseModal}>×</button>
            <div className="video-modal__wrapper">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;